/**
 * /ops — Reference spoke workspace (beta empty-state). Surface Layer (/01)
 *
 * The reference operational domain mounts as one area under /ops and
 * cannot redefine hub-level navigation.
 */

import { createFileRoute } from '@tanstack/react-router';
import { Button, Tag, Tile } from '@carbon/react';
import { Events } from '@carbon/icons-react';
import '../styles/views.scss';

export const Route = createFileRoute('/ops')({
  component: OpsView,
});

function OpsView() {
  return (
    <div className="view">
      <header className="view__header">
        <h1 className="view__title">Operations</h1>
        <p className="view__subtitle">The reference operational learning domain.</p>
      </header>
      <Tile className="view-empty view__grid">
        <Events size={32} aria-hidden="true" />
        <h2>Operations spoke</h2>
        <p className="view-tile__label">
          The reference spoke is part of the beta roadmap. It mounts as a single domain area and reuses the same command contract as native engines.
        </p>
        <Tag type="cool-gray">Beta roadmap</Tag>
        <Button kind="tertiary" disabled>
          Open reference spoke
        </Button>
      </Tile>
    </div>
  );
}
